export default __webpack_public_path__ + "22f6c4333ea30428973f6e57691c5195.png";